"use strict";

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _classCallCheck = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
var _createClass = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRANSCRIPTION_DATA_MESSAGE_TOPIC = void 0;
var TranscriptEvent_1 = require("./TranscriptEvent");
exports.TRANSCRIPTION_DATA_MESSAGE_TOPIC = 'aws:chime:transcription';
var DefaultTranscriptionController = /*#__PURE__*/function () {
  function DefaultTranscriptionController(realtimeController) {
    _classCallCheck(this, DefaultTranscriptionController);
    this.realtimeController = realtimeController;
    this.transcriptEventCallbacks = new Set();
  }
  _createClass(DefaultTranscriptionController, [{
    key: "subscribeToTranscriptEvent",
    value: function subscribeToTranscriptEvent(callback) {
      var _this = this;
      if (this.transcriptEventCallbacks.size === 0) {
        this.realtimeController.realtimeSubscribeToReceiveDataMessage(exports.TRANSCRIPTION_DATA_MESSAGE_TOPIC, function (dataMessage) {
          var _iterator = _createForOfIteratorHelper(TranscriptEvent_1.TranscriptEventConverter.from(dataMessage)),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var transcriptEvent = _step.value;
              var _iterator2 = _createForOfIteratorHelper(_this.transcriptEventCallbacks),
                _step2;
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  var transcriptEventCallback = _step2.value;
                  transcriptEventCallback(transcriptEvent);
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        });
      }
      this.transcriptEventCallbacks.add(callback);
    }
  }, {
    key: "unsubscribeFromTranscriptEvent",
    value: function unsubscribeFromTranscriptEvent(callback) {
      this.transcriptEventCallbacks.delete(callback);
      if (this.transcriptEventCallbacks.size === 0) {
        this.realtimeController.realtimeUnsubscribeFromReceiveDataMessage(exports.TRANSCRIPTION_DATA_MESSAGE_TOPIC);
      }
    }
  }]);
  return DefaultTranscriptionController;
}();
exports.default = DefaultTranscriptionController;